import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { ContactsCommentTemplate } from './variants/ContactsComment'
import { ContactsSlideTemplate } from './variants/ContactsSlide'

const commentVariant = {
  ...productRowVariantForPath('contacts', 2),
  Template: ContactsCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('contacts', 3),
  Template: ContactsSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('contacts')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
